<div class="puzzleContainer">
    <div *ngIf="awaitingPixiInitialize()">
        <div 
            #pixiInput 
            class="puzzlePlayButton center-button"
            (click)="pixiInputClicked()">
            <fa-icon [icon]="['fas', 'play']"  size="4x"></fa-icon>
        </div>
    </div>
    <div *ngIf="!awaitingPixiInitialize()" #overlayDiv [id]="'puzzleOverlay' + myId" class="puzzleOverlay">
            <div 
                #nextButton
                *ngIf="isPuzzleAnswerCorrect() && !shouldShowDisabledSubmit()" 
                class="puzzleNextButton scale-on-hover"
                (click)="onSubmitClicked()">
                <fa-icon [icon]="['fas', 'paper-plane']"  size="4x"></fa-icon>
            </div>

            <div 
                #nextButtonDisabled
                *ngIf="shouldShowDisabledSubmit()" 
                class="puzzleNextButtonDisabled"
                (click)="onDisabledSubmitClicked()">
                <fa-icon [icon]="['fas', 'paper-plane']"  size="4x"></fa-icon>
            </div>

            <div
                #playButton
                *ngIf="shouldShowPlayButton()"
                class="play-button top-left-button scale-on-hover"
                (click)="onPlayClicked()">
                <fa-icon [icon]="['fas', 'play']"  size="4x"></fa-icon>
        </div>

            <div
                #resetButtonTopLeft
                *ngIf="shouldShowResetCorrect()"
                class="retry-button top-left-button scale-on-hover"
                (click)="onTryAgainClicked()">
                <fa-icon [icon]="['fas', 'redo']"  size="4x"></fa-icon>
            </div>

            <div
                #resetButtonCenter
                *ngIf="shouldShowResetIncorrect()"
                class="retry-button center-button scale-on-hover rotate"
                (click)="onTryAgainClicked()">
                <fa-icon [icon]="['fas', 'redo']"  size="4x"></fa-icon>
            </div>

            <div
                #tryAgainButton
                *ngIf="shouldDisplayTryAgain()"
                class="retry-button center-button rotate"
                (click)="onTryAgainClicked()">
                <fa-icon [icon]="['fas', 'redo']"  size="4x"></fa-icon>
            </div>
    </div>
    <div [id]="'puzzleSvgContainer' + myId" class="puzzleSvgContainer">
        <ng-content></ng-content>
    </div>
</div>
